<div class="py-5">
    <div>
        <div class="q-button-group q-right-align">
            @if (isReadOnly && !parentValue) {
                <span>Last recorded value</span>
            }
        </div>

        <div>
            @if (query.condition === 'or') {
                OR
            } @else {
                AND
            }
        </div>
    </div>

    <div class="q-tree-container">
        <ul class="q-tree">
            @for (rule of query.rules; track $index; let i = $index) {
                @let local = { isRuleset: !!rule.rules };
                <li class="q-row q-connector q-transition q-rule "
                    [ngClass]="(!local.isRuleset && (rule.isLastRecordedValueObsolete || !rule.datapointName || (!!rule.entityIdRight && !rule.datapointNameRight))) ? 'cbms-yellowBg' : rule.isMatching ? 'cbms-redBg' : ''">
                    @if (!local.isRuleset) {
                        @if (isReadOnly) {
                            <div class="q-control-size">
                                    {{ rule.datapointName ?? DATA_POINT_DOES_NOT_EXIST }}
                            </div>
                            @if (comparisonType === STATIC) {
                                <div class="q-control-size">
                                    is flatline for duration of = {{ rule.flatLineAmount }} {{ rule.flatLineUnit }}
                                </div>
                            } @else {
                                <div class="q-control-size">
                                        {{ rule.operator }}
                                </div>
                                @if (!!rule.entityIdRight) {
                                    <div class="q-control-size">
                                            {{ rule.datapointNameRight ?? DATA_POINT_DOES_NOT_EXIST }}
                                    </div>
                                } @else {
                                    <div class="q-control-size">
                                            {{ rule.value }}
                                    </div>
                                }
                            }
                            <div class="ml-auto">
                                @if (!!rule.entityIdRight) {
                                    <span>{{ rule.lastRecordedValueInActiveState }}</span>
                                } @else {
                                    <span>{{ rule.matchWithValue }}</span>
                                }
                            </div>
                        }
                    }
                    @if (local.isRuleset) {
                        <cc-query-builder
                            [comparisonType]="comparisonType"
                            [isReadOnly]="isReadOnly"
                            [parentValue]="query"
                            [query]="rule"
                        ></cc-query-builder>
                    }
                </li>
            }
        </ul>
    </div>
</div>
